import Link from '@tiptap/extension-link';

export default Link.configure({
  HTMLAttributes: {
    class: 'text-green-500 hover:text-green-600 hover:underline',
  },
});
